import { render } from "./App.vue?vue&type=template&id=c2acb86a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c2acb86a&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__